<template>
  <div v-if="poll !== null">
    <messageModal v-if="showMessage" message="Votre participation a été enregistré ! à bientôt pour les résultats." @closeMessage="showMessage = false"></messageModal>
    <div class="panel">
      <div class="row columns">
        <div class="large-5 columns mt-3 ml-2">
          <div class="panel-title">Bienvenue sur le premier <span class="bold">BINGO EdF !</span></div>
          <p class="small-font">Le jeu que même les anglais, avec qui je discute, nous envient</p>
        </div>
        <div class="large-6 columns mr-2">
          <img src="http://back.bloodbowlclub.com/static/medias/uploads/cropped/Bingo-PNG-HD.png" alt="">
        </div>
      </div>
      <hr>
      <template v-if="status == 'running'">
        <template v-if="guimode==='select'">
          <div class="row columns">
            <div class="large-12 columns">
              <div class="panel-title justified">Qu'est-ce que c'est ?</div>
            </div>
            <div class="large-12 columns">
              <div class="normal-font justified ml-2">C'est le jeu de pronostic qui fera éclater aux yeux de tous ta clairvoyance,
                et ta maitrise des statistiques. </div>
            </div>
          </div>
          <br>
          <div class="row columns">
            <div class="large-12 columns">
              <div class="panel-title justified">Comment que je joue ?</div>
            </div>
            <div class="large-12 columns">
              <div class="normal-font justified ml-2">Je choisis quel est, selon moi, le coach qui va devenir sélectionneur,
                et pareil pour les 8 qui vont commposer son Equipe de Champion.
                <strong>Les participations seront closes dimanche 10 Novembre, la veille du vote.</strong>
              </div>
            </div>
          </div>
          <br>
          <div class="row columns">
            <div class="large-12 columns">
              <div class="panel-title justified">Qu'est ce que je gagne ?</div>
            </div>
            <div class="large-12 columns">
              <div class="normal-font justified ml-2">Notre partenaire, la ligue de Condate, offre généreusement un cadeau
                pour la prochaine édition du breizh bowl</div>
            </div>
          </div>
          <br>
        </template>
        <template v-else>
          <div class="row columns">
            <div class="large-12 columns">
              <div class="panel-title justified">Merci d'avoir joué avec nous !</div>
            </div>
            <div class="large-12 columns">
              <div class="normal-font justified ml-2">Juste le temps de finir de se la mesurer sur le forum, et on vous dit
                qui a gagné !!!</div>
            </div>
          </div>
        </template>
        <div class="row columns">
          <div class="large-12 columns">
            <div v-if="guimode==='select'" class="panel-title justified">C'est parti !</div>
            <div v-if="guimode==='consult'" class="panel-title justified">Mes réponses</div>
          </div>
          <div class="large-5 columns">
            <div class="normal-font pt-1 text-left">1/ Je choisis le selectionneur qui va gagner: </div>
          </div>
          <div class="large-4 columns">
            <div class="normal-font text-left">
              <select v-if="guimode=='select'" v-model="chosenSelectionneur">
                <option value="0">choisissez un projet</option>
                <option :value="p.id" v-for="p in poll.questions[0].possibilities">{{p.possibility_text}}</option>
              </select>
              <input v-if="guimode==='consult'" type="text" disabled v-for="p in $store.getters.pollResponseForQuestion(1,1)" v-model="p.chosen_possibility">
            </div>
          </div>
          <div class="large-2 columns"/>
        </div>
        <br>
        <div class="row columns">
          <div class="medium-5 columns text-centered">
            <div class="normal-font pt-1 text-left">2/ Je choisis les joueurs qui vont avec: </div>
          </div>
          <div class="large-4 columns">
            <div v-if="guimode==='select'" v-for="i in 8" class="normal-font text-left mb-1">
              <multiselect
                v-model="chosenCoaches[i]"
                :options="poll.questions[1].possibilities"
                :multiple="false"
                :close-on-select="true"
                :clear-on-select="true"
                :preserve-search="true"
                placeholder="choisir un coach"
                label="possibility_text"
                track-by="possibility_text"
                :preselect-first="false">
              </multiselect>
            </div>
            <div v-if="guimode==='consult'" class="normal-font text-left">
              <input v-if="guimode==='consult'" type="text" disabled v-for="p in $store.getters.pollResponseForQuestion(1,2)" v-model="p.chosen_possibility">
            </div>
          </div>
          <div class="large-2 columns"/>
        </div>
        <br>
        <div class="row columns">
          <div class="large-8 large-offset-2 columns text-centered error-lbl">
            {{this.errorMsg}}
          </div>
        </div>
        <br>
        <div v-if="guimode==='select'" class="row columns">
          <div class="large-3 large-offset-4 columns text-centered">
            <button @click="savePronos()">Enregistrer mes pronostics</button>
          </div>
        </div>
        <br>
      </template>
      <template v-if="status === 'finished'">
        <br>
       <h1> Voilà, c'est terminé, merci d'avoir joué ! </h1>
        <br>
        <h5>Les réusltats seront dévoilés dans quelques jours !</h5>
        <br>
      </template>
      <template>
        <h2>Chicagork remporte le bingo EDF !!</h2>
        <img src="http://back.bloodbowlclub.com/static/medias/uploads/cropped/chicagork_O1vcrDJ.jpg" alt="">
      </template>
      </div>
    </div>
</template>

<script>
import { mapGetters } from 'vuex'
import poll from '@/api/poll-game.api'
import messageModal from '../common/message-modal.vue'
import spinner from '../common/spinner.vue'
import Multiselect from 'vue-multiselect'

export default {
  name: 'bingo-edf',
  components: {
    spinner,
    messageModal,
    Multiselect
  },
  data () {
    return {
      chosenSelectionneur: null,
      chosenCoaches: null,
      errorMsg: '',
      guimode: 'select',
      showMessage: false,
      status: 'winner'
    }
  },
  computed: {
    ...mapGetters([
      'poll',
      'pollResponses'
    ])
  },
  watch: {
    pollResponses: function (newPollResponses, oldState) {
      console.log('poll responses received')
      this.guimode = 'consult'
    }
  },
  methods: {
    savePronos () {
      this.errorMsg = ''
      let datas = []
      this.chosenCoaches.forEach(coach => {
        datas.push({
          'user': this.$store.getters.currentUser.id,
          'chosen_possibility': coach.id
        })
      })
      datas.push({
        'user': this.$store.getters.currentUser.id,
        'chosen_possibility': this.chosenSelectionneur
      })
      if (datas.length !== 9) {
        this.errorMsg = 'Il faut choisir toutes les réponses d\'un coup, sinon ça marche pas'
        return
      }
      console.log(datas)
      poll.api.createPollResponse(datas)
        .then(response => {
          this.showMessage = true
          this.$store.dispatch('getPollResponse', 1)
        }, error => {
          console.log(error)
        })
    }
  },
  created () {
    this.$store.dispatch('hideLeaguePanel')
    this.$store.dispatch('activateFullSizePage')
    this.$store.dispatch('getPoll', 1)
    this.$store.dispatch('getPollResponse', 1)
    this.chosenCoaches = new Array(8)
  }
}
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style scoped>

  .mt-3 {
    margin-top: 1rem;
  }

  .ml-2 {
    margin-left: 1rem;
  }

  .ml-4 {
    margin-left: 3rem;
  }

  .mb-1 {
    margin-bottom: 0.5rem;
  }

  .mr-2 {
    margin-right: 1rem;
  }

  .panel-title {
    font-size: 2rem;
    font-weight: 400;
  }
  .bold {
    font-weight: bold;
    font-size: 2.8rem;
  }
  .justified {
    text-align: justify;
  }
  .small-font {
    font-size: 0.8rem;
  }

  .normal-font {
    font-size: 1.1rem;
  }

  .pt-1 {
    padding-top: 0.4rem;
  }
</style>



// WEBPACK FOOTER //
// bingo-edf.vue?115b24ac